export const RouteUrls = {
    Logout: "/logout",
    Login: "/login",
    Signup: "/signup",
    WorkRemoteLanding: "/workremote/landing",
    AdvancedConfiguration: "/workremote/configuration"
}